import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import { useEditModeStore } from '@/stores/editMode'

// Shared rule for showing an in-place content ✎ affordance: the user is an admin AND edit mode is on.
// Used by both ContentText (inline section blocks) and ContentRegion (whole-page blocks) so the live
// editing experience is identical across every content surface.
export function useEditAffordance() {
  const { user } = storeToRefs(useAuthStore())
  const editMode = useEditModeStore()
  const showAffordance = computed(() => user.value?.role === 'ADMIN' && editMode.on)
  return { showAffordance }
}
